export const markdown = `
🚀 **Sloyd V2 Release** (JAN 30, 2025)  
Early access to the next version of **3D modeling**.  

### What's New?  
- 🛠 **Single-Object Editor** - Focus on single models.  
- 🎨 **4,000+ Material Library** - with AI texturing.  
- 🤝 **Real-Time Collaboration** - Edit with others.  
- 🔗 **Project Sharing** - Share models via links.  
- 📤 **Improved Exporting** - GLBs with instructions.  
- 📦 **Asset Packs** - Manage custom collections.  
- 📋 **Copy/Paste** - cross-projects.  

🚀 Try Sloyd V2 now.  
`;
